import { render, staticRenderFns } from "./RegionGroup.vue?vue&type=template&id=5f2e1274&scoped=true"
import script from "./RegionGroup.vue?vue&type=script&lang=js"
export * from "./RegionGroup.vue?vue&type=script&lang=js"
import style0 from "./RegionGroup.vue?vue&type=style&index=0&id=5f2e1274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2e1274",
  null
  
)

export default component.exports